<div class="rangebox">
    <button data-target="#collapse522" data-toggle="collapse" class="collapsebtn" type="button">Hotel Name</button>
    <div class="vsm-item">
        <div class="search-container" id="collapse522">
            <input type="text" #searchInputRef class="search-input text-capitalize" placeholder="Search by Hotel Name"
            (input)="searchHotels($event.target.value)"  [ngStyle]="{'background-image': 'url(' + searchIcon + ')'}">
        </div>
    </div>
</div>
